import { SIGN_OUT } from '../auth/types';

import * as TYPES from './types';

export const initialState = {
  pending: false,
  notifications: {
    data: [],
    count: 0,
    pending: false,
    pageNumber: 1,
    pageItemCount: 50,
  },
  campaigns: {
    data: [],
    count: 0,
    pending: false,
    pageNumber: 1,
    pageItemCount: 25,
  },
  notificationTokens: [],
  notificationFavoriteTokens: [],
  notificationTemplates: [],
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.SET_NOTIFICATIONS_PENDING:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          pending: action.payload,
        },
      };

    case TYPES.SET_NOTIFICATIONS_DATA:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          data: action.payload.data,
          count: action.payload.count,
        },
      };

    case TYPES.SET_NOTIFICATIONS_PAGE_NUMBER:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          pageNumber: action.payload,
        },
      };

    case TYPES.SET_NOTIFICATIONS_PAGE_ITEM_COUNT:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          pageItemCount: action.payload,
        },
      };

    case TYPES.SET_CAMPAIGNS_PENDING:
      return { ...state, campaigns: { ...state.campaigns, pending: action.payload } };

    case TYPES.SET_CAMPAIGNS_DATA:
      return { ...state, campaigns: { ...state.campaigns, data: action.payload.data, count: action.payload.count } };

    case TYPES.SET_CAMPAIGNS_PAGE_NUMBER:
      return { ...state, campaigns: { ...state.campaigns, pageNumber: action.payload } };

    case TYPES.SET_CAMPAIGNS_PAGE_ITEM_COUNT:
      return { ...state, campaigns: { ...state.campaigns, pageItemCount: action.payload } };

    case TYPES.SET_PENDING:
      return {
        ...state,
        pending: action.payload,
      };

    case TYPES.SET_NOTIFICATIONS_TOKENS:
      return {
        ...state,
        notificationTokens: action.payload,
      };

    case TYPES.SET_NOTIFICATIONS_FAVORITE_TOKENS:
      return {
        ...state,
        notificationFavoriteTokens: action.payload,
      };

    case TYPES.SET_NOTIFICATIONS_TEMPLATES:
      return {
        ...state,
        notificationTemplates: action.payload,
      };

    case SIGN_OUT:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};
